import React, { useEffect, useState } from "react";
import Back from "../../../components/back";
import { useParams } from "react-router-dom";
import useRequest from "../../../components/hooks/use-request";
import Details from "./details";

interface DetailsProps {
  ticket: {
    assignedTo: {
      fullname: string;
    },
    id: string;
    fullName: string;
    email: string;
    status: string;
    created_at: string;
    ticketId: string;
    message: string;
    subject: string;
    attachment:string[];
    phone:string;
  };
}

const RequestDetails = () => {
  const [request, setRequest] = useState<DetailsProps>();
  const { id } = useParams<{ id: string }>();
  const { makeRequest: getRequestById } = useRequest(
    `/customer-support/tickets/${id}`,
    "GET"
  );

  // The ticket endpoint can briefly return a 502 right after an assign. Retry a
  // couple of times, and never overwrite a valid ticket with a failed response
  // (doing so would wipe request.ticket.id and break re-assignment).
  const fetchData = async (retries = 2) => {
    // Suppress the error toast on every attempt except the last one
    const [response, statusCode] = await getRequestById(undefined, undefined, {
      silent: retries > 0,
    });
    if (statusCode >= 200 && statusCode < 300 && response?.data) {
      setRequest(response.data);
      return;
    }
    if (retries > 0) {
      setTimeout(() => fetchData(retries - 1), 1500);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <div className="flex gap-5 mt-5">
        <Back />
        <h2 className="text-[24px] font-bold">
          Requests/Ticket ID: {request?.ticket?.ticketId}
        </h2>
      </div>
      <Details request={request} refetch={fetchData} />
    </>
  );
};

export default RequestDetails;
